import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import DebugNode from '@appblocks/codegeneration/Nodes/DebugNode';
import NodeLink from '@appblocks/codegeneration/Nodes/NodeLink';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import SystemNode from '@appblocks/codegeneration/Nodes/SystemNode';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import TimerNode from '@appblocks/codegeneration/Nodes/TimerNode';
import Tibbit43_1Node from '@appblocks/codegeneration/Nodes/Tibbit43_1Node';
import Tibbit39_1Node from '@appblocks/codegeneration/Nodes/Tibbit39_1Node';
import Tibbit39_2Node from '@appblocks/codegeneration/Nodes/Tibbit39_2Node';
import Tibbit39_3Node from '@appblocks/codegeneration/Nodes/Tibbit39_3Node';
import Tibbit39_4Node from '@appblocks/codegeneration/Nodes/Tibbit39_4Node';
import ModbusNode from '@appblocks/codegeneration/Nodes/ModbusNode';
import ModbusResponseNode from '@appblocks/codegeneration/Nodes/ModbusResponseNode';
import ModbusTimeoutNode from '@appblocks/codegeneration/Nodes/ModbusTimeoutNode';
import ModbusWriteNode from '@appblocks/codegeneration/Nodes/ModbusWriteNode';
import SocketNode from '@appblocks/codegeneration/Nodes/SocketNode';
import HTTPNode from '@appblocks/codegeneration/Nodes/HTTPNode';
import MQTTPubNode from '@appblocks/codegeneration/Nodes/MQTTPubNode';
import MQTTSubNode from '@appblocks/codegeneration/Nodes/MQTTSubNode';
import MQTTConnectedNode from '@appblocks/codegeneration/Nodes/MQTTConnectedNode';
import AzureNode from '@appblocks/codegeneration/Nodes/AzureNode';
import AzureTelemetryNode from '@appblocks/codegeneration/Nodes/AzureTelemetryNode';
import AzurePropertyNode from '@appblocks/codegeneration/Nodes/AzurePropertyNode';
import AzureCommandNode from '@appblocks/codegeneration/Nodes/AzureCommandNode';
import WM2000LightNode from '@appblocks/codegeneration/Nodes/WM2000LightNode';
import WM2000TempNode from '@appblocks/codegeneration/Nodes/WM2000TempNode';
import Tibbit02Node from '@appblocks/codegeneration/Nodes/Tibbit02Node';
import Tibbit03_1Node from '@appblocks/codegeneration/Nodes/Tibbit03_1Node';
import Tibbit03_2Node from '@appblocks/codegeneration/Nodes/Tibbit03_2Node';
import LCDGraphNode from '@appblocks/codegeneration/Nodes/LCDGraphNode';
import LCDNode from '@appblocks/codegeneration/Nodes/LCDNode';
import LCDTextWidgetNode from '@appblocks/codegeneration/Nodes/LCDTextWidgetNode';
import LCDCardWidgetNode from '@appblocks/codegeneration/Nodes/LCDCardWidgetNode';
import LCDGraphWidgetNode from '@appblocks/codegeneration/Nodes/LCDGraphWidgetNode';
import LCDImageWidgetNode from '@appblocks/codegeneration/Nodes/LCDImageWidgetNode';
import KeypadReleasedNode from '@appblocks/codegeneration/Nodes/KeypadReleasedNode';
import KeypadNode from '@appblocks/codegeneration/Nodes/KeypadNode';
import SleepNode from '@appblocks/codegeneration/Nodes/SleepNode';
import WifiWM2000Node from '@appblocks/codegeneration/Nodes/WifiWM2000Node';
import WifiNode from '@appblocks/codegeneration/Nodes/WifiNode';
import UpgradeFirmwareNode from '@appblocks/codegeneration/Nodes/UpgradeFirmwareNode';
import DateTimeNode from '@appblocks/codegeneration/Nodes/DateTimeNode';
import SerialPeripheralNode from '@appblocks/codegeneration/Nodes/SerialPeripheralNode';
import ButtonNode from '@appblocks/codegeneration/Nodes/ButtonNode';
import WM2000PWMLEDNode from '@appblocks/codegeneration/Nodes/WM2000PWMLEDNode';
import WiegandNode from '@appblocks/codegeneration/Nodes/WiegandNode';
import TableNode from '@appblocks/codegeneration/Nodes/TableNode';
import Tibbit43_2Node from '@appblocks/codegeneration/Nodes/Tibbit43_2Node';
import Tibbit63_2Node from '@appblocks/codegeneration/Nodes/Tibbit63_2Node';
import Tibbit39Node from '@appblocks/codegeneration/Nodes/Tibbit39Node';
import ModbusSlaveNode from '@appblocks/codegeneration/Nodes/ModbusSlaveNode';
import Tibbit01Node from '@appblocks/codegeneration/Nodes/Tibbit01Node';
import Tibbit06Node from '@appblocks/codegeneration/Nodes/Tibbit06Node';
import HTTPServerEndpointNode from '@appblocks/codegeneration/Nodes/HTTPServerEndpointNode';
import LUISNode from '@appblocks/codegeneration/Nodes/LUISNode';
import AbsoluteValueNode from '@appblocks/codegeneration/Nodes/DataTransformations/AbsoluteValueNode';
import Tibbit63_1Node from '@appblocks/codegeneration/Nodes/Tibbit63_1Node';
import ArithmeticNode from '@appblocks/codegeneration/Nodes/Arithmetic/ArithmeticNode';
import CompoundConditionNode from '@appblocks/codegeneration/Nodes/CompoundConditionNode';
import ComparisonNode from '@appblocks/codegeneration/Nodes/ComparisonNode';
import CustomFunctionNode from '@appblocks/codegeneration/Nodes/CustomFunctionNode';
import LCDMenuNode from '@appblocks/codegeneration/Nodes/LCDMenuNode';
import CggTelemetryNode from '@appblocks/codegeneration/Nodes/CggTelemetryNode';
import NodeGroup from '@appblocks/codegeneration/Nodes/NodeGroup';
import PatternNode from '@appblocks/codegeneration/Nodes/pat/PatternNode';
import PatternNtiosNode from '@appblocks/codegeneration/Nodes/pat/PatternNtiosNode';
import NodeGroupInput from '@appblocks/codegeneration/Nodes/NodeGroupInput';
import NodeGroupOutput from '@appblocks/codegeneration/Nodes/NodeGroupOutput';
import BeepNode from '@appblocks/codegeneration/Nodes/Beep/BeepNode';
import BitwiseNode from '@appblocks/codegeneration/Nodes/BitwiseNode';
import Tibbit40_1Node from '@appblocks/codegeneration/Nodes/Tibbit40_1Node';
import Tibbit40_2Node from '@appblocks/codegeneration/Nodes/Tibbit40_2Node';
import Tibbit40_3Node from '@appblocks/codegeneration/Nodes/Tibbit40_3Node';
import Tibbit40_4Node from '@appblocks/codegeneration/Nodes/Tibbit40_4Node';
import SystemHaltNode from '@appblocks/codegeneration/Nodes/SystemHaltNode';
import VariableChangedNode from '@appblocks/codegeneration/Nodes/VariableChangedNode';
import VariableUpdatedNode from '@appblocks/codegeneration/Nodes/VariableUpdatedNode';
import VariableSetNode from '@appblocks/codegeneration/Nodes/VariableSetNode';
import TimerStartNode from '@appblocks/codegeneration/Nodes/TimerStartNode';
import TimerCompletedNode from '@appblocks/codegeneration/Nodes/TimerCompletedNode';
import TimerStopNode from '@appblocks/codegeneration/Nodes/TimerStopNode';
import Tibbit16Node from '@appblocks/codegeneration/Nodes/Tibbit16Node';
import Tibbit17Node from '@appblocks/codegeneration/Nodes/Tibbit17Node';
import CronEventNode from '@appblocks/codegeneration/Nodes/CronEventNode';
import SocketDataNode from '@appblocks/codegeneration/Nodes/SocketDataNode';
import Tibbit26StartNode from '@appblocks/codegeneration/Nodes/Tibbit26StartNode';
import ButtonReleasedNode from '@appblocks/codegeneration/Nodes/ButtonReleasedNode';
import NodeArgument from '@appblocks/codegeneration/Nodes/NodeArgument';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import MathNode from '@appblocks/codegeneration/Nodes/MathNode';
import ConditionNode from '@appblocks/codegeneration/Nodes/ConditionNode';
import MathCompoundNode from '@appblocks/codegeneration/Nodes/MathCompoundNode';
import ForLoopNode from '@appblocks/codegeneration/Nodes/ForLoopNode';
import Tibbit26EndNode from '@appblocks/codegeneration/Nodes/Tibbit26EndNode';
import Tibbit26SendNode from '@appblocks/codegeneration/Nodes/Tibbit26SendNode';
import TableInsertNode from '@appblocks/codegeneration/Nodes/TableInsertNode';
import TableUpdateNode from '@appblocks/codegeneration/Nodes/TableUpdateNode';
import CommandTriggeredNode from '@appblocks/codegeneration/Nodes/CommandTriggeredNode';
import CommandTriggerNode from '@appblocks/codegeneration/Nodes/CommandTriggerNode';
import LogAddNode from '@appblocks/codegeneration/Nodes/LogAddNode';
import SystemRebootNode from '@appblocks/codegeneration/Nodes/SystemRebootNode';
import SettingsInitializeNode from '@appblocks/codegeneration/Nodes/SettingsInitializeNode';
import LabelNode from '@appblocks/codegeneration/Nodes/LabelNode';
import DateTimeFormatNode from '@appblocks/codegeneration/Nodes/DateTimeFormatNode';
import NetworkDisconnectedNode from '@appblocks/codegeneration/Nodes/NetworkDisconnectedNode';
import InterruptNode from '@appblocks/codegeneration/Nodes/InterruptNode';
import NetworkChangedNode from '@appblocks/codegeneration/Nodes/NetworkChangedNode';
import SerialDataNode from '@appblocks/codegeneration/Nodes/SerialDataNode';
import PicoLEDNode from '@appblocks/codegeneration/Nodes/PicoLEDNode';
import SerialDataSendNode from '@appblocks/codegeneration/Nodes/SerialDataSendNode';
import LCDSetScreenNode from '@appblocks/codegeneration/Nodes/LCDSetScreenNode';
import ButtonInputNode from '@appblocks/codegeneration/Nodes/ButtonInputNode';
import ButtonInputReleasedNode from '@appblocks/codegeneration/Nodes/ButtonInputReleasedNode';
import SMSNode from '@appblocks/codegeneration/Nodes/SMSNode';
import TimeDelayNode from '@appblocks/codegeneration/Nodes/TimeDelayNode';
import DigitalLineSetNode from '@appblocks/codegeneration/Nodes/DigitalLineSetNode';
import SocketConnectNode from '@appblocks/codegeneration/Nodes/SocketConnectNode';
import SocketEventNode from '@appblocks/codegeneration/Nodes/SocketEventNode';
import SMSRecvNode from '@appblocks/codegeneration/Nodes/SMSRecvNode';
import LCDGraphWidgetClearNode from '@appblocks/codegeneration/Nodes/LCDGraphWidgetClearNode';
import HTTPServerResponseNode from '@appblocks/codegeneration/Nodes/HTTPServerResponseNode';
import JSONGetStringNode from '@appblocks/codegeneration/Nodes/JSONGetStringNode';

const NodesMap: { [featureId: string]: any } = {
    node_link: NodeLink,
    node_argument: NodeArgument,
    node_port: NodePort,
    node_parameter: NodeParameter,
    node_group: NodeGroup,
    node_group_input: NodeGroupInput,
    node_group_output: NodeGroupOutput,

    node_debug: DebugNode,
    node_system: SystemNode,
    node_time_interval: TimerNode,
    // node_timer: TimerOneShotNode,
    node_timer_start: TimerStartNode,
    node_timer_completed: TimerCompletedNode,
    node_timer_stop: TimerStopNode,
    // node_tibbit_00_1: Tibbit00_1Node,
    node_tibbit_01: Tibbit01Node,
    node_tibbit_02: Tibbit02Node,
    // node_tibbit_03_1: Tibbit03_1Node,
    // node_tibbit_03_2: Tibbit03_2Node,
    // node_tibbit_06: Tibbit06Node,
    node_tibbit_16: Tibbit16Node,
    node_tibbit_17: Tibbit17Node,
    node_tibbit_26_start: Tibbit26StartNode,
    node_tibbit_26_end: Tibbit26EndNode,
    node_tibbit_26_send: Tibbit26SendNode,
    node_tibbit_39_1: Tibbit39_1Node,
    node_tibbit_39_2: Tibbit39_2Node,
    node_tibbit_39_3: Tibbit39_3Node,
    node_tibbit_39_4: Tibbit39_4Node,
    node_tibbit_40_1: Tibbit40_1Node,
    node_tibbit_40_2: Tibbit40_2Node,
    node_tibbit_40_3: Tibbit40_3Node,
    node_tibbit_40_4: Tibbit40_4Node,
    node_tibbit_43_1: Tibbit43_1Node,
    node_tibbit_43_2: Tibbit43_2Node,
    node_tibbit_63_1: Tibbit63_1Node,
    node_tibbit_63_2: Tibbit63_2Node,
    node_modbus_register: ModbusNode,
    node_modbus_response: ModbusResponseNode,
    node_modbus_timeout: ModbusTimeoutNode,
    node_modbus_write: ModbusWriteNode,
    node_arithmetic: ArithmeticNode,
    node_bitwise: BitwiseNode,
    node_system_halt: SystemHaltNode,
    // node_system_tick: SystemTickNode,
    // node_add: AddNode,
    // node_subtract: SubtractNode,
    // node_multiply: MultiplyNode,
    // node_divide: DivideNode,
    // node_ethernet: EthernetNode,
    node_socket: SocketNode,
    node_socket_data_arrival: SocketDataNode,
    node_http: HTTPNode,
    // node_mqtt: MQTTNode,
    node_mqtt_pub: MQTTPubNode,
    node_mqtt_sub: MQTTSubNode,
    node_mqtt_connected: MQTTConnectedNode,
    node_variable_changed: VariableChangedNode,
    node_variable_updated: VariableUpdatedNode,
    node_variable_set: VariableSetNode,
    node_azure: AzureNode,
    node_azure_telemetry: AzureTelemetryNode,
    node_azure_property: AzurePropertyNode,
    node_azure_command: AzureCommandNode,
    node_wm2000ev_light: WM2000LightNode,
    node_wm2000ev_temp: WM2000TempNode,
    node_lcd_graph: LCDGraphNode,
    node_lcd: LCDNode,
    node_lcd_text_widget: LCDTextWidgetNode,
    node_lcd_card_widget: LCDCardWidgetNode,
    node_lcd_graph_widget: LCDGraphWidgetNode,
    node_lcd_image_widget: LCDImageWidgetNode,
    node_keypad: KeypadNode,
    node_keypad_released: KeypadReleasedNode,
    node_disconnected_network: NetworkDisconnectedNode,
    node_sleep: SleepNode,
    node_wifiwm2000: WifiWM2000Node,
    node_wifi: WifiNode,
    node_upgrade_firmware: UpgradeFirmwareNode,
    node_datetime: DateTimeNode,
    node_ser: SerialPeripheralNode,
    node_button: ButtonNode,
    node_button_released: ButtonReleasedNode,
    node_wm2000ev_led: WM2000PWMLEDNode,
    node_wiegand: WiegandNode,
    node_table: TableNode,
    node_table_insert: TableInsertNode,
    node_table_update: TableUpdateNode,
    node_modbus_slave_register: ModbusSlaveNode,
    node_http_server_endpoint: HTTPServerEndpointNode,
    node_http_server_response: HTTPServerResponseNode,
    node_luis: LUISNode,
    node_abs: AbsoluteValueNode,
    node_custom: CustomFunctionNode,
    node_lcd_menu: LCDMenuNode,
    node_cgg_telemetry: CggTelemetryNode,
    node_pico_led: PicoLEDNode,
    node_pat: PatternNode,
    node_forloop: ForLoopNode,
    node_beep: BeepNode,
    node_cron_event: CronEventNode,
    node_comparison: ComparisonNode,
    node_compound_condition: CompoundConditionNode,
    node_condition: ConditionNode,
    node_math: MathNode,
    node_math_compound: MathCompoundNode,
    node_command_triggered: CommandTriggeredNode,
    node_command_trigger: CommandTriggerNode,
    node_log_add: LogAddNode,
    node_system_reboot: SystemRebootNode,
    node_settings_init: SettingsInitializeNode,
    node_label: LabelNode,
    node_datetime_format: DateTimeFormatNode,
    node_interrupt: InterruptNode,
    node_network_changed: NetworkChangedNode,
    node_ser_data_arrival: SerialDataNode,
    node_ser_data_send: SerialDataSendNode,
    node_lcd_set_screen: LCDSetScreenNode,
    node_button_input_pressed: ButtonInputNode,
    node_button_input_released: ButtonInputReleasedNode,
    node_sms_send: SMSNode,
    node_time_delay: TimeDelayNode,
    node_digital_line_set: DigitalLineSetNode,
    node_socket_connect: SocketConnectNode,
    node_socket_event: SocketEventNode,
    node_sms_recv: SMSRecvNode,
    node_lcd_graph_widget_clear: LCDGraphWidgetClearNode,
    node_json_get_string: JSONGetStringNode,
};

export default class Nodes {
    static getItem(itemId: string, project: ProjectConfiguration) {
        try {
            if (NodesMap[itemId] !== undefined) {
                if (project.runtime
                    && NodesMap[itemId][project.runtime] !== undefined) {
                    return new NodesMap[itemId][project.runtime]();
                }
                return new NodesMap[itemId]();
            }
        } catch (e) {
            return undefined;
        }
        return undefined;
    }

    static getList() {
        return Object.keys(NodesMap);
    }
}
